import { useMemo } from "react";

import { useWorkspaceEntitlement } from "@/hooks/useWorkspaceEntitlement";

export const useWorkspaceUnitBalance = () => {
  const { entitlement } = useWorkspaceEntitlement();

  const { remainingUnits, consumedUnits } = useMemo(() => {
    if (!entitlement || Object.keys(entitlement).length === 0) {
      return {
        remainingUnits: null,
        consumedUnits: null,
      };
    }

    const remainingUnits = Math.round(
      (entitlement.balance ?? 0) - (entitlement.overage ?? 0),
    );

    return {
      remainingUnits,
      consumedUnits: entitlement.usage || 0,
    };
  }, [entitlement]);

  const totalUnits = (remainingUnits ?? 0) + (consumedUnits ?? 0);
  const percentageRemaining =
    100 * (totalUnits > 0 ? (remainingUnits ?? 0) / totalUnits : 0);

  return {
    remainingUnits,
    percentageRemaining,
  };
};
